import { classnames } from '@aibees/shared/utils';
import { memo, useMemo } from 'react';
import {
  EXPORT_TEMPLATE_MAX_LIMIT,
  EXPORT_TEMPLATE_MAX_LIMIT_FOR_INTEGRATION,
} from '../../constant';
import { useTemplateContext } from '../../context';
import * as Styled from './styles';
import * as SX from './sx';
import type { ExportTemplateMaxValueErrorProps as Props } from './types';

export const ExportTemplateMaxValueError = memo(
  ({ className, integrationConfig }: Props) => {
    const { showLimit } = useTemplateContext();

    const maxLimit = useMemo(
      () =>
        integrationConfig
          ? EXPORT_TEMPLATE_MAX_LIMIT_FOR_INTEGRATION
          : EXPORT_TEMPLATE_MAX_LIMIT,
      [integrationConfig]
    );

    if (!showLimit?.value) return false;

    return (
      <Styled.Wrapper
        className={classnames('ExportTemplateMaxValueError', className)}
        sx={SX.root}
        message={`This columns is Limited to ${maxLimit} column.`}
        variant="standard"
        severity="error"
        icon={false}
      />
    );
  }
);

ExportTemplateMaxValueError.displayName = 'ExportTemplateMaxValueError';
